const Index = () => import('views/vod/Index')
const Home = () => import('views/vod/Home')
const VideoPage = () => import('views/vod/VideoPage')
const AlbumPlaylist = () => import('views/vod/AlbumPlaylist')
const SearchIndex = () => import('views/vod/SearchIndex')
const ShareVideo = () => import('views/vod/ShareVideo')
const TimelineIndex = () => import('views/vod/Timeline')
const RegionIndex = () => import('views/vod/Region')
const VideoTag = () => import('views/vod/VideoTag')
const AlbumIndex = () => import('views/vod/AlbumIndex')
const AlbumImage = () => import('views/vod/AlbumImage')

export default {
  path: '/vod',
  name: 'Vod',
  component: Index,
  meta: { needAuth: false },
  children: [
    {
      path: '',
      name: 'Home',
      component: Home,
      meta: { needAuth: false }
    },
    {
      path: '/vod/timeline',
      name: 'TimelineIndex',
      component: TimelineIndex,
      meta: { needAuth: true }
    },
    {
      path: '/vod/region',
      name: 'RegionIndex',
      component: RegionIndex,
      meta: { needAuth: false }
    },
    {
      path: '/vod/search',
      name: 'SearchIndex',
      component: SearchIndex,
      meta: { needAuth: false },
      children: [
      ]
    },
    {
      path: '/vod/video/:id',
      name: 'VideoPage',
      component: VideoPage,
      meta: { needAuth: false }
    },
    {
      path: '/vod/video/tag/:tag',
      name: 'VideoTag',
      component: VideoTag,
      meta: { needAuth: false }
    },
    {
      path: '/vod/image/:albumId',
      name: 'AlbumImage',
      component: AlbumImage,
      meta: { needAuth: false }
    },
    {
      path: '/vod/playlist',
      name: 'AlbumIndex',
      component: AlbumIndex,
      meta: { needAuth: false }
    },
    {
      path: '/vod/playlist/:albumId',
      name: 'AlbumPlaylist',
      component: AlbumPlaylist,
      meta: { needAuth: false }
    },
    {
      path: '/vod/s/:shareId',
      name: 'ShareVideo',
      component: ShareVideo,
      meta: { needAuth: false }
    }
  ]
}
